import styled from 'styled-components';

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const FormField = styled.div`
    width: 100%;
    display: flex;
    gap: 10px;
`;

export const FormControlWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
`;

export const ControlItem = styled.div``;
